/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useEffect, useState, Fragment, useMemo } from 'react'
import {
  Button,
  Grid,
  OutlinedAddon,
  OutlinedAdornment,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  TextField,
  Divider,
} from '@maas-components/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  Form,
  Formik,
  FormikErrors,
  FormikHelpers,
  FormikProps,
  FormikTouched,
  FormikValues,
} from 'formik'
import { ReactComponent as CrossHairImg } from 'core/assets/images/crosshair.svg'
import { ReactComponent as PackageImg } from 'core/assets/images/package.svg'
import * as Analytics from 'core/common/analytics'
import {
  AnalyticsFormMode,
  AnalyticsProductPackageField,
} from 'core/common/analytics/productFormEvents/types'
import { DEFAULT_VARIATION_OPTIONS_BY_TYPE } from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import convertDecimalPlaces from 'core/common/utils/convertDecimalPlaces'
import { isBoolean, isNumber } from 'core/common/utils/is'
import { getErrorMessage, validateField } from 'core/common/utils/validation'
import CardStep from 'core/components/CardStep'
import BulkModeButton from 'core/components/Multivariation/VariationValue/BulkModeButton'
import VariationItemView from 'core/components/Variations/VariationItemView'
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import { TProductInitialValues, TVariation } from 'core/pages/ProductNew-v2/types'
import { findFreight } from 'core/services/http'
import { TFreights } from 'core/services/models/freight'
import freightsValues from '../../../netshoes/data/dimensions.json'
import ControlForm from './components/ControlForm'
import DimensionForm from './components/DimensionForm'
import { PACKAGE_OPTIONS, ProductFreightV2Values } from './constants'
import { SimpleProductFreightSchema, VariationProductFreightSchema } from './schema'
import * as S from './style'

type ProductFreightV2Props = {
  onNext: () => void
  isEditMode?: boolean
  onEditSubmit?: (formData: unknown) => void
  navigateToStep: (stepKey: string) => void
  custom?: any
  formMode: AnalyticsFormMode
}

type ProductPackageField = 'weight' | 'depth' | 'width' | 'height'

const fieldTranslations: Record<ProductPackageField, string> = {
  weight: 'peso',
  depth: 'comprimento',
  width: 'largura',
  height: 'altura',
}

const allowedFields: ProductPackageField[] = ['weight', 'depth', 'width', 'height']

const ProductFreightV2 = ({
  onNext,
  isEditMode,
  onEditSubmit,
  navigateToStep,
  custom,
  formMode,
}: ProductFreightV2Props) => {
  const { formData, setFormData } = useFormContext()
  const initialValues: ProductFreightV2Values = {
    package: {
      weight: {
        value: formData.package?.weight?.value || 0,
      },
      depth: formData.package?.depth || 0,
      width: formData.package?.width || 0,
      height: formData.package?.height || 0,
      dimensionUn: formData.package?.unit || 'm',
      weightUn: formData.package?.weight?.unit || 'kg',
      standard_package: formData.package?.standard_package || false,
      selectedFreightId: formData?.package.selectedFreightId || '',
    },
    variations: formData.variations.map((variation: TVariation) => ({
      ...variation,
      package: {
        ...variation.package,
        weight: {
          value: isNumber(variation.package?.weight)
            ? variation.package?.weight
            : variation.package?.weight?.value,
        },
      },
    })),
  }

  const hasVariations = !!formData.variations?.length

  const bulkModeDefault = isBoolean(formData.bulkMode?.freightForm)
    ? formData.bulkMode?.freightForm
    : true

  const [isBulkMode, setBulkMode] = useState<boolean>(bulkModeDefault)
  const [expanded, setExpanded] = useState<string[]>([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedWeight, setSelectedWeight] = useState(initialValues.package.weightUn)
  const [selectedDimension, setSelectedDemension] = useState(initialValues.package.dimensionUn)
  const [selectedPackage, setSelectedPackage] = useState(
    initialValues.package.standard_package ? PACKAGE_OPTIONS[1].value : PACKAGE_OPTIONS[0].value
  )
  const [selectedFreights, setSelectedFreights] = useState<string | string[]>([])
  const [freights, setFreights] = useState([...freightsValues] as TFreights[])
  const [standardPackage, setStandardPackage] = useState(false)

  const isWeightGrams = selectedWeight === 'g'

  const toggleBulkMode = () => {
    setBulkMode(prevBulkMode => !prevBulkMode)
  }

  useEffect(() => {
    findFreight().then(data => setFreights(data.data))
  }, [])

  useEffect(() => {
    if (formData.pendingFieldsVariationFlow) {
      toggleBulkMode()
    }
  }, [formData.pendingFieldsVariationFlow])

  useEffect(() => {
    const submitEdit = async () => {
      if (isSubmitting && isEditMode && onEditSubmit) {
        setIsSubmitting(false)
        setIsLoading(true)
        try {
          await onEditSubmit(formData)
          setIsLoading(false)
        } catch (error) {
          console.error('Error during API call', error)
        } finally {
          setIsLoading(false)
        }
      }
    }

    submitEdit()
  }, [isSubmitting, formData, isEditMode, onEditSubmit])

  const onSubmit = (values: typeof initialValues) => {
    const packageValue: Partial<{
      weight: number | { value: number; unit?: string }
      depth: number
      width: number
      height: number
      unit?: string
      standard_package?: boolean
      selectedFreightId?: any
    }> = {
      weight: {
        value: Number(values.package?.weight?.value),
        unit: selectedWeight,
      },
      depth: Number(values.package?.depth),
      width: Number(values.package?.width),
      height: Number(values.package?.height),
      unit: selectedDimension,
      standard_package: selectedPackage === 'standard',
      selectedFreightId: selectedFreights,
    }

    Analytics.ProductPackageSaved(formMode)

    setFormData((prevData: { bulkMode: any }) => {
      const updatedPackage = !custom
        ? packageValue
        : {
            ...packageValue,
            unit: selectedDimension,
          }

      return isBulkMode
        ? {
            ...prevData,
            package: updatedPackage,
            variations: values.variations?.map(variation => ({
              ...variation,
              package: updatedPackage,
            })),
            bulkMode: {
              ...(prevData.bulkMode || {}),
              freightForm: true,
            },
          }
        : {
            ...prevData,
            package: updatedPackage,
            variations: values.variations?.map(variation => {
              const newPackageValue = !custom
                ? {
                    ...variation.package,
                    weight: {
                      value: Number(variation.package?.weight?.value) || 1,
                    },
                  }
                : {
                    ...variation.package,
                    weight: {
                      value: Number(variation.package?.weight?.value) || 1,
                      unit: selectedWeight,
                    },
                    unit: selectedDimension,
                  }

              return {
                ...variation,
                package: newPackageValue,
              }
            }),
            bulkMode: {
              ...(prevData.bulkMode || {}),
              freightForm: false,
            },
          }
    })

    if (formData.pendingFieldsVariationFlow) navigateToStep('publication-1')

    setIsSubmitting(true)
    setExpanded([])
    onNext()
  }

  const handleValidation = async ({ validateForm }: Pick<FormikProps<any>, 'validateForm'>) => {
    const errors = await validateForm()
    const { package: packageErrors, variations } = errors

    if (packageErrors) {
      Object.keys(packageErrors).forEach(field => {
        if (allowedFields.includes(field as ProductPackageField)) {
          const translatedField = fieldTranslations[field as ProductPackageField] || field
          Analytics.ProductPackageValidationError(
            formMode,
            translatedField as AnalyticsProductPackageField
          )
        }
      })
    }

    if (variations && Array.isArray(variations)) {
      variations.forEach(variation => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const packageVariationsErrors = variation?.package

        if (packageVariationsErrors) {
          Object.keys(packageVariationsErrors).forEach(field => {
            if (allowedFields.includes(field as ProductPackageField)) {
              const translatedField = fieldTranslations[field as ProductPackageField] || field
              Analytics.ProductPackageValidationError(
                formMode,
                translatedField as AnalyticsProductPackageField
              )
            }
          })
        }
      })
    }
  }

  const handleVariationsValidation = async (formik: FormikProps<ProductFreightV2Values>) => {
    if (hasVariations && !isBulkMode) {
      const errors = await formik.validateForm()
      const { variations } = formik.values

      if (errors.variations && Array.isArray(errors.variations)) {
        const errorPanels = variations
          .map((variation, index) => {
            if (Array.isArray(errors.variations) && errors.variations[index]) {
              return variation.id
            }

            return null
          })
          .filter(Boolean) as string[]
        setExpanded(prev => Array.from(new Set([...prev, ...errorPanels])))
      }
    }
  }

  const handleAccordionChange =
    (panel: string) => (event: React.ChangeEvent<unknown>, isExpanded: boolean) => {
      setExpanded(prev => (isExpanded ? [...prev, panel] : prev.filter(item => item !== panel)))
    }

  const handleChangeWeight = (
    value: string,
    setFieldValue: FormikHelpers<FormikValues>['setFieldValue']
  ) => {
    setFieldValue('package.weightUn', value)
    setSelectedWeight(value)
  }

  const handleChangeDimension = (
    value: string,
    setFieldValue: FormikHelpers<FormikValues>['setFieldValue']
  ) => {
    setFieldValue('package.dimensionUn', value)
    setSelectedDemension(value)
  }

  const handleChangePackage = (value: string) => {
    if (value === 'standard') {
      setSelectedDemension('cm')
    }

    setStandardPackage(value === 'standard')
    setSelectedPackage(value)
  }

  const handleChangleFreight = (freightId: string, variationIndex: number, setFieldValue: any) => {
    const freightsGroups = custom?.freights ?? freights

    if (isBulkMode) {
      freightsGroups.forEach((freightGroup: any, freightGroupIndex: number) => {
        const selectedFreight = freightGroup.values.find(({ id }: { id: any }) => id === freightId)

        if (selectedFreight) {
          Object.entries(selectedFreight).forEach(([key, val]) => {
            setFieldValue(`package.${key}`, val)
          })
        }
      })

      setSelectedFreights(freightId)
      return
    }

    const updatedSelectedFreights = Array.isArray(selectedFreights)
      ? [...selectedFreights]
      : [selectedFreights]

    updatedSelectedFreights[variationIndex] = freightId

    freightsGroups.forEach((freightGroup: any, freightGroupIndex: number) => {
      const selectedFreight = freightGroup.values.find(({ id }: { id: any }) => id === freightId)

      if (selectedFreight) {
        Object.entries(selectedFreight).forEach(([key, val]) => {
          if (key === 'id') {
            setFieldValue(`variations.${variationIndex}.package.selectedFreightId`, val)
            setFieldValue(`package.${key}`, val)
            return
          }

          setFieldValue(`variations.${variationIndex}.package.${key}`, val)
          setFieldValue(`package.${key}`, val)
        })
      }
    })
    // Esse valor fixo, é para que a validação funcione, em caso de variação, na hora de salvar
    // será considerado as variações e não a chave package.
    setFieldValue('package.weight.value', 1)
    setSelectedFreights(updatedSelectedFreights)
  }

  const wrappedHandleChangleFreight = (setFieldValue: any) => {
    return (value: string, index: number) => {
      handleChangleFreight(value, index, setFieldValue)
    }
  }

  const convertGramsToInt = (value: string) => parseInt(value, 10).toString()

  const renderVariationHeader = (variationItem: TVariation) => {
    const variationAttributes = variationItem.customAttributes.map(attribute => ({
      label: attribute.value,
      showAvatar: attribute.type === 'color',
      color:
        attribute.type === 'color'
          ? DEFAULT_VARIATION_OPTIONS_BY_TYPE.color.find(
              colorOption => colorOption.title === attribute.value
            )?.color
          : undefined,
    }))

    return (
      <Box className="d-flex align-center mr-3" key={0}>
        <div
          className="d-flex justify-center mr-2"
          style={{
            borderColor: '#CECFD1',
            borderRadius: 4,
            borderWidth: 1,
            borderStyle: 'solid',
            height: 48,
            width: 48,
            overflow: 'hidden',
          }}
        >
          <img
            src={variationItem.images?.[0]?.url}
            alt="Imagem de uma variação do produto"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>

        {variationAttributes.map((attribute, index) => (
          <Fragment key={index}>
            <VariationItemView variation={attribute} />
            {index !== variationAttributes.length - 1 && <span className="mr-1">/</span>}
          </Fragment>
        ))}
      </Box>
    )
  }

  const renderDimensionsFieldsByVariation = (
    formikProps: FormikProps<ProductFreightV2Values>,
    {
      errors,
      touched,
      submitCount,
      values,
      handleBlur,
      setFieldValue,
    }: {
      errors: FormikErrors<FormikValues>
      touched: FormikTouched<FormikValues>
      submitCount: number
      values: FormikValues
      handleBlur: (e: React.FocusEvent<unknown>) => void
      setFieldValue: FormikHelpers<FormikValues>['setFieldValue']
    }
  ) => {
    return values.variations.map((variationItem: TVariation, index: number) => {
      return (
        <div key={index}>
          <Accordion
            key={variationItem.id}
            style={{ boxShadow: 'none' }}
            expanded={expanded.includes(variationItem.id)}
            onChange={handleAccordionChange(variationItem.id)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              {renderVariationHeader(variationItem)}
            </AccordionSummary>
            <AccordionDetails>
              <Grid
                container
                spacing={2}
                style={{
                  backgroundColor: '#F7F7F7',
                  borderRadius: 8,
                  borderWidth: 1,
                  borderColor: '#ECECEC',
                  borderStyle: 'solid',
                }}
                className="py-3 px-2"
              >
                <Grid item md={1}>
                  <CrossHairImg height="54" />
                </Grid>
                <Grid item xs={3}>
                  <OutlinedAdornment
                    position="end"
                    error={validateField(
                      `variations.${index}.package.weight.value`,
                      errors,
                      touched,
                      submitCount > 0
                    )}
                  >
                    <TextField
                      error={validateField(
                        `variations.${index}.package.weight.value`,
                        errors,
                        touched,
                        submitCount > 0
                      )}
                      helperText={getErrorMessage(
                        `variations.${index}.package.weight.value`,
                        errors,
                        touched
                      )}
                      onBlur={handleBlur}
                      variant="outlined"
                      label={i18n.t('productNew.logistic.weightLabelForm')}
                      name={`variations.${index}.package.weight.value`}
                      value={values.variations?.[index]?.package?.weight?.value?.toString()}
                      onChange={e => {
                        let newValue = e.target.value.slice(0, 7)

                        if (isWeightGrams) newValue = convertGramsToInt(newValue)

                        setFieldValue(
                          `variations.${index}.package.weight.value`,
                          convertDecimalPlaces(newValue)
                        )
                      }}
                      style={{ backgroundColor: '#fff' }}
                      type="number"
                    />
                    <OutlinedAddon position="end">{selectedWeight}</OutlinedAddon>
                  </OutlinedAdornment>
                </Grid>
                <Grid container item xs={12} spacing={2}>
                  <Grid item md={1}>
                    <PackageImg height="54" />
                  </Grid>
                  <DimensionForm
                    key={index}
                    index={index}
                    selectedDimension={selectedDimension}
                    selectedPackage={selectedPackage}
                    selectedFreights={selectedFreights[index] || ''}
                    freights={custom ? custom.freights : freights}
                    handleChangleFreight={value =>
                      handleChangleFreight(value, index, setFieldValue)
                    }
                    variationIndex={index}
                    formikValidations={{
                      validateField,
                      getErrorMessage,
                      formikProps,
                    }}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Divider />
        </div>
      )
    })
  }

  const validationSchema = useMemo(() => {
    if (selectedPackage === 'standard' && !hasVariations) {
      return SimpleProductFreightSchema
    }
    return hasVariations && !isBulkMode ? VariationProductFreightSchema : SimpleProductFreightSchema
  }, [selectedPackage, hasVariations, isBulkMode])

  const setDefaultFreightValues = () => {
    if (isBulkMode) {
      const { selectedFreightId } = formData.package

      if (selectedFreightId) {
        setSelectedFreights(selectedFreightId)
      }
    } else {
      const { variations } = formData

      if (variations.length) {
        let selectedFreightIds: string[] = []

        variations.forEach(({ package: pkg }: { package: any }) => {
          if (pkg?.selectedFreightId) {
            selectedFreightIds = [...selectedFreightIds, pkg.selectedFreightId]
          }
        })

        setSelectedFreights(selectedFreightIds)
      }
    }
  }

  useEffect(() => {
    setDefaultFreightValues()
  }, [isBulkMode])

  return (
    <Formik
      key={selectedPackage}
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      validationSchema={validationSchema}
    >
      {formikProps => (
        <Form className="w-100">
          <S.Container>
            <CardStep
              title={!isEditMode && i18n.t('productNew.logistic.title')}
              description={i18n.t('productNew.logistic.description')}
              headerAction={
                hasVariations && (
                  <BulkModeButton isBulkMode={isBulkMode} show onClick={toggleBulkMode} />
                )
              }
            >
              <ControlForm
                selectedDimension={selectedDimension}
                selectedWeight={selectedWeight}
                selectedPackage={selectedPackage}
                onChangeWeight={value => handleChangeWeight(value, formikProps.setFieldValue)}
                onChangeDimension={value => handleChangeDimension(value, formikProps.setFieldValue)}
                onChangePackage={handleChangePackage}
              />

              {!isBulkMode ? (
                renderDimensionsFieldsByVariation(formikProps, formikProps)
              ) : (
                <Grid
                  container
                  spacing={2}
                  style={{
                    backgroundColor: '#F7F7F7',
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: '#ECECEC',
                    borderStyle: 'solid',
                  }}
                  className="py-3 px-2"
                >
                  <Grid item md={1}>
                    <CrossHairImg height="54" />
                  </Grid>
                  <Grid item xs={3}>
                    <OutlinedAdornment
                      position="end"
                      error={validateField(
                        'package.weight.value',
                        formikProps.errors,
                        formikProps.touched,
                        formikProps.submitCount > 0
                      )}
                    >
                      <TextField
                        error={validateField(
                          'package.weight.value',
                          formikProps.errors,
                          formikProps.touched,
                          formikProps.submitCount > 0
                        )}
                        onBlur={formikProps.handleBlur}
                        variant="outlined"
                        helperText={getErrorMessage(
                          'package.weight.value',
                          formikProps.errors,
                          formikProps.touched
                        )}
                        label={i18n.t('productNew.logistic.weightLabelForm')}
                        name="package.weight.value"
                        value={formikProps.values.package.weight?.value?.toString()}
                        onChange={e => {
                          let newValue = e.target.value.slice(0, 7)

                          if (isWeightGrams) newValue = convertGramsToInt(newValue)

                          formikProps.setFieldValue(
                            'package.weight.value',
                            convertDecimalPlaces(newValue)
                          )
                        }}
                        style={{ backgroundColor: '#fff' }}
                        type="number"
                      />
                      <OutlinedAddon position="end">{selectedWeight}</OutlinedAddon>
                    </OutlinedAdornment>
                  </Grid>
                  <Grid container item xs={12} spacing={2}>
                    <Grid item md={1}>
                      <PackageImg height="54" />
                    </Grid>
                    <DimensionForm
                      index={0}
                      selectedDimension={selectedDimension}
                      selectedPackage={selectedPackage}
                      selectedFreights={
                        Array.isArray(selectedFreights) ? selectedFreights[0] : selectedFreights
                      }
                      freights={custom ? custom.freights : freights}
                      handleChangleFreight={wrappedHandleChangleFreight(formikProps.setFieldValue)}
                      formikValidations={{
                        validateField,
                        getErrorMessage,
                        formikProps,
                      }}
                    />
                  </Grid>
                </Grid>
              )}

              <div className="w-100 d-flex justify-end mt-4">
                {!isEditMode && (
                  <>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => {
                        formikProps.resetForm()
                      }}
                      className="mr-2"
                    >
                      <span>Cancelar</span>
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        formikProps.handleSubmit()
                        handleVariationsValidation(formikProps)
                        handleValidation({ validateForm: formikProps.validateForm })
                      }}
                    >
                      {i18n.t('productNew.actions.continue')}
                    </Button>
                  </>
                )}

                {isEditMode && (formikProps.dirty || isLoading) && (
                  <>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => formikProps.resetForm()}
                      className="mr-2"
                    >
                      <span>Cancelar</span>
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        formikProps.handleSubmit()
                        handleVariationsValidation(formikProps)
                        handleValidation({ validateForm: formikProps.validateForm })
                      }}
                      loading={isLoading}
                    >
                      <span>Salvar</span>
                    </Button>
                  </>
                )}
              </div>
            </CardStep>
          </S.Container>
        </Form>
      )}
    </Formik>
  )
}

export default memo(ProductFreightV2)
